























import { Component, Prop, Vue } from "vue-property-decorator";
import Programmer from "./Programmer.vue";
import Blog from "@/components/Blog";

@Component({})
export default class About extends Vue {
  @Prop() isDay!: boolean;
  @Prop() onToggle!: Function;
}
